import React from "react";

import { getDisplayNameFromKey, getTileName } from "../../utils";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";

const ViewChartItemForModal = ({ item }) => {
    const tileName = getTileName(item);
    const displayName = getDisplayNameFromKey(item.name, item.isUserDoc);
    return (
        <div className="drag-item">
            <div className="top-sec">
                <div className="icon">
                    <img src="/img/icon-squre.svg" />
                </div>
            </div>
            <div className="cont-sec mt-2 pl-2">
                <div className="icons-sec">
                    <img src={`/img/${item.entityIcon}`} />
                </div>
                <div className="tile-name-badge-container">
                    <EllipsisTooltipText text={displayName} className="chart-item-title-text" asHeading />
                    {tileName ? (
                        <EllipsisTooltipText text={tileName} className="tile-name-badge mt-1" tooltipPlace="top" />
                    ) : null}
                </div>
            </div>
        </div>
    );
};
export default ViewChartItemForModal;
